import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Action = GlassFrogModel.extend({}, {
  resourceName: 'actions',
  defaults: {
  },
})

export default Action
